<template>
  <div class="page-content" style="overflow: auto;">
    <!-- <div class="box-office-daily"> -->
      <h1 class="page-title">{{ $locale("sideMenu.reports.box") }}</h1>

      <!-- Search Area -->
      <el-row :gutter="10" class="search-area">
        <el-col :span="15">
          <!-- <DatePickerGroup
            v-bind:start="filter.startDate"
            v-bind:end="filter.endDate"
            @setFatherDate="getDate"
            :disabled="isShowDetail"
            :isNotLimit="true"
          ></DatePickerGroup> -->
          <DatePickerGroup
              v-model="filter"
              :showWeekly="true"
              :disabled="isShowDetail"
            ></DatePickerGroup>
          <el-button
            class="egl-btn-yellow"
            @click="filter_fn"
          >{{ $locale("global.search") }}</el-button>
        </el-col>
        <el-col :span="9" class="ta-r">
          <el-button class="egl-btn-yellow right-align-btn" :disabled="isShowDetail" @click="exportCSV_fn">{{ $locale("global.exportToCSV") }}</el-button>
          <el-button class="egl-btn-yellow" v-print="printObj">{{ $locale("global.printBtn") }}</el-button>
          <!-- <el-button class="egl-btn-yellow right-align-btn" :disabled="isShowDetail">{{ $locale("global.print") }}</el-button> -->
        </el-col>
      </el-row>
      <div class="checkbox-group">

        <el-row>
          <el-col :span="3">{{ $locale('trans.report.version.grouping') }}</el-col>
          <el-col :span="12">
            <el-checkbox-group
              v-model="checkboxGroup"
              :disabled="isShowDetail"
            >
              <el-checkbox label="version">{{ $locale('global.screenStandard') }}</el-checkbox>
              <el-checkbox label="subtitlesVersion">{{ $locale('trans.report.version.caption') }}</el-checkbox>
              <el-checkbox label="otherVersion">{{ $locale('global.otherVersions') }}</el-checkbox>
              <el-checkbox label="displaySamePrice">{{ $locale('trans.report.displaySamePrice') }}</el-checkbox>
            </el-checkbox-group>
          </el-col>
          <el-col :span="6">
            <el-checkbox-group v-model="mobilization" :disabled="isShowDetail">
              <el-checkbox label="freeMobilize">{{$locale("trans.box.freeMobilize")}}</el-checkbox>
              <el-checkbox label="adjustMobilize"
                >{{$locale("trans.box.adjustMobilize")}}</el-checkbox
              >
            </el-checkbox-group>
          </el-col>
        </el-row>
      </div>

      <div class="table-module info-supplement-container">
        <el-row>
          <el-col :span="6"><h3 class="info-title">{{$locale("trans.box.displayShowBack")}}</h3></el-col>
          <el-col :span="6" v-if="isShowDetail"><el-button
            class="egl-btn-yellow"
            @click="filter_fn"
            style="margin-top:12px"
          >{{ $locale("global.search") }}</el-button></el-col>
        </el-row>
        <el-row class="search-area info-summary">
          <el-col :span="12">
            <el-row :gutter="20">
              <el-col :span="8">
                <el-select
                  :placeholder="$locale('trans.box.plsSelectFilm')"
                  v-model="showRule.movie"
                  @change="selectFilm_fn"
                  filterable
                  remote
                  clearable
                >
                  <el-option
                    v-for="item in allFilmOption"
                    :label="item.filmName"
                    :value="item.filmId"
                    :key="item.filmId"
                  ></el-option>
                </el-select>
              </el-col>
              <el-col :span="8">
                <el-select
                  :placeholder="$locale('trans.box.plsSelectSchedule')"
                  v-model="showRule.scheduleTime"
                  @change="selectScheduleTime_fn"
                  clearable>
                  <el-option
                    v-for="item in scheduleTimeOption"
                    :label="item.date"
                    :value="item.date"
                    :key="item.date"
                  ></el-option>
                </el-select>
              </el-col>
              <el-col :span="8">
                <el-select
                  :placeholder="$locale('trans.box.plsSelectSchedule')"
                  v-model="showRule.schedule"
                  @change="getDetailTable_fn"
                  clearable>
                  <el-option
                    v-for="item in allSchedleOption"
                    :label="getScheduleFormatTimeText(item)"
                    :value="item.scheduleId"
                    :key="item.scheduleId"
                  ></el-option>
                </el-select>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-checkbox-group v-model="showRule.coupon">
              <el-checkbox label="showDetail">{{$locale("trans.box.withoutTicket")}}</el-checkbox>
              <el-checkbox label="notUseCoupon"
                >{{$locale("trans.box.breakDown")}}</el-checkbox
              >
              <el-checkbox label="withoutTransactions">{{$locale("trans.box.witchoutTransactions")}}</el-checkbox>
              <el-checkbox label="displaySamePrice">{{ $locale('trans.report.displaySamePrice') }}</el-checkbox>
              <el-checkbox label="displayUnitPriceZero">{{ $locale('trans.report.unitPrice') }}</el-checkbox>
            </el-checkbox-group>
          </el-col>
          <el-col :span="4">
            <el-checkbox-group v-model="showRule.mobilization">
              <el-checkbox label="freeMobilize">{{$locale("trans.box.freeMobilize")}}</el-checkbox>
              <el-checkbox label="adjustMobilize"
                >{{$locale("trans.box.adjustMobilize")}}</el-checkbox
              >
            </el-checkbox-group>
          </el-col>
        </el-row>
        <p>行の表示設定</p>
        <el-row style="margin-top: 15px;">
          <el-col :span="6">
            <el-select
              v-model="selectLabels"
              multiple
            >
              <el-option v-for="(item, idx) in columnLabels" :label="item.label" :value="item.value" :key="idx"></el-option>
            </el-select>
          </el-col>
        </el-row>
      </div>
      <div id="print">
        <div class="table-module info-supplement-container">
        <el-row>
          <el-col :span="6"><h3 class="info-title">{{!isShowDetail ? $locale("trans.box.title-period") : $locale("trans.box.title-back")}}</h3></el-col>
          <el-col :span="6"><h3 class="info-title" style="font-size: 14px;">{{ $locale("global.cinemaName") }}:{{ cinemaName }}</h3></el-col>
        </el-row>
        <el-row class="module-sms" :gutter="10" v-if="!isShowDetail">
          <el-col :span="8" v-if="onSearch.startDate !== 0 && onSearch.endDate !== 0">
            {{ $locale('trans.report.period') }}:{{ $moment(onSearch.startDate).format("YYYY-MM-DD") }} （{{ weekLocaleArray[$moment(onSearch.startDate).day()] }}{{ $locale("calendar.weekday") }}） ~ {{ $moment(onSearch.endDate).format("YYYY-MM-DD") }} （{{ weekLocaleArray[$moment(onSearch.endDate).day()] }}{{ $locale("calendar.weekday") }}）
          </el-col>
          <el-col :span="6" v-else>{{ $locale('trans.report.period') }}:</el-col>
          <el-col :span="10">{{ $locale('trans.report.generatedate') }}:{{ searchTime }}</el-col>
        </el-row>
        <el-row class="module-sms" v-else>
          <el-col :span="6">{{ $locale("trans.box.scheduleTime") }}:{{ scheduleTime }}</el-col>
          <el-col :span="6">{{ $locale("tran.box.brandName")}}:{{ brandName }}</el-col>
          <el-col :span="6">{{ $locale('trans.report.generatedate') }}:{{ searchTimeDetail }}</el-col>
        </el-row>

        <el-row>
          <el-col :span="24" class="custom-border-table film-table boxOffice" v-if="!isShowDetail">
            <!-- <el-table :data="tableData1.tableData" class="egl-table list-table" :span-method="mergeSpan" border>
              <el-table-column prop="filmName" width="260">
                <template slot="header">
                  <el-dropdown :hide-on-click="false">
                    <span class="el-dropdown-link">
                      {{ $locale('global.titleOfWork')}}<i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item v-for="(text, index) in tableData1.checkbox.filmName" :key="index">
                        <el-checkbox
                          :checked="true"
                          @change="(val) => tableHeaderFilter(val, 'filmName', index)">
                          {{ text }}
                        </el-checkbox>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </template>
              </el-table-column>
              <el-table-column width="160">
                <template slot="header">
                  <el-dropdown :hide-on-click="false">
                    <span class="el-dropdown-link">
                      {{ $locale('global.screenStandard') }}<i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item v-for="(text, index) in tableData1.checkbox.version" :key="index">
                        <el-checkbox
                          :checked="true"
                          @change="(val) => tableHeaderFilter(val, 'version', index)">
                          {{ text }}
                        </el-checkbox>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </template>
                <template slot-scope="scope">
                  <span v-if="typeof(scope.row.version) == 'string'">{{ scope.row.version }}</span>
                  <span v-else>{{ scope.row.version.toString() }}</span>
                </template>
              </el-table-column>
              <el-table-column width="140">
                <template slot="header">
                  <el-dropdown :hide-on-click="false">
                    <span class="el-dropdown-link">
                      {{ $locale('trans.report.version.caption') }}<i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item v-for="(text, index) in tableData1.checkbox.subtitlesVersion" :key="index">
                        <el-checkbox
                          :checked="true"
                          @change="(val) => tableHeaderFilter(val, 'subtitlesVersion', index)">
                          {{ text }}
                        </el-checkbox>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </template>
                <template slot-scope="scope">
                  <span v-if="typeof(scope.row.subtitlesVersion) == 'string'">{{ scope.row.subtitlesVersion }}</span>
                  <span v-else>{{ scope.row.subtitlesVersion.toString() }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="otherVersion">
                <template slot="header">
                  <el-dropdown :hide-on-click="false">
                    <span class="el-dropdown-link">
                      {{ $locale('global.otherVersions') }}<i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item v-for="(text, index) in tableData1.checkbox.otherVersion" :key="index">
                        <el-checkbox
                          :checked="true"
                          @change="(val) => tableHeaderFilter(val, 'otherVersion', index)">
                          {{ text }}
                        </el-checkbox>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </template>
                <template slot-scope="scope">
                  <span v-if="typeof(scope.row.otherVersion) == 'string'">{{ scope.row.otherVersion }}</span>
                  <span v-else>{{ scope.row.otherVersion.toString() }}</span>
                </template>
              </el-table-column>
              <el-table-column label="公開周" prop="week"></el-table-column>
              <el-table-column label="配給" prop="distributor"></el-table-column>
              <template v-if="tableData1.tableData.length > 0">
                <el-table-column v-for="(text, i) in ticketNameArr" :key="i" :label="text">
                  <el-table-column label="枚数" width="100">
                    <template slot-scope="scope">
                      <span v-if="tableData1.tableData[scope.$index].ticketMsg[i].num == 0">/</span>
                      <span v-else>{{ tableData1.tableData[scope.$index].ticketMsg[i].num }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column :label="$locale('global.amount')">
                    <template slot-scope="scope">
                      <span v-if="tableData1.tableData[scope.$index].ticketMsg[i].price == 0">/</span>
                      <span v-else>{{ tableData1.tableData[scope.$index].ticketMsg[i].price }}</span>
                    </template>
                  </el-table-column>
                </el-table-column>
              </template>
              <el-table-column label="合計" prop="lineTotal" align="center"></el-table-column>
            </el-table> -->
            <el-table
              :data="tableData1.tableData"
              class="egl-table list-table boxPeriod"
              border
              :span-method="objectSpanMethod"
              @filter-change="filterChange_fn"
            >
              <el-table-column
                prop="filmName"
                :label="$locale('global.titleOfWork')"
                width="260"
                :filters="filterTypes.films"
                :filtered-value="filterValues.films"
                column-key="filmId"
              ></el-table-column>
              <el-table-column
                v-if="selectLabels.includes('version')"
                prop="version"
                :label="$locale('global.screenStandard')"
                width="80"
                :filters="filterTypes.versions"
                :filtered-value="filterValues.versions"
                column-key="version"
              ></el-table-column>
              <el-table-column
                v-if="selectLabels.includes('subtitlesVersion')"
                prop="subtitlesVersion"
                :label="$locale('trans.report.version.caption')"
                width="80"
                :filters="filterTypes.subtitlesVersions"
                :filtered-value="filterValues.subtitlesVersions"
                column-key="subtitlesVersion"
              ></el-table-column>
              <el-table-column
                v-if="selectLabels.includes('otherVersion')"
                prop="otherVersion"
                :label="$locale('global.otherVersions')"
                width="80"
                :filters="filterTypes.otherVersions"
                :filtered-value="filterValues.otherVersions"
                column-key="otherVersion"
              ></el-table-column>
              <el-table-column
                v-if="selectLabels.includes('week')"
                prop="week"
                :label="$locale('trans.box.week')"
                width="70"
              ></el-table-column>
              <el-table-column
                v-if="selectLabels.includes('clientName')"
                prop="clientName"
                :label="$locale('trans.box.clientName')"
                width="140"
              ></el-table-column>
              <!-- BoxOfficeType -->
              <template v-if="getIsExistBoxOffice('boxOffice')">
                <el-table-column
                :label="$locale('movie.mainBusiness')"
                align="center"
              >
                <el-table-column
                  prop="boxOffice.visitor"
                  :label="$locale('cashierReport.dialog.th.cashQty')"
                  width="50"
                  align="right"
                ></el-table-column>
                <el-table-column
                  prop="boxOffice.total"
                  :label="$locale('trans.other.price')"
                  width="100"
                  :formatter="priceFormatter_fn"
                  align="right"
                ></el-table-column>
                </el-table-column>
              </template>
              <template v-if="getIsExistBoxOffice('lateShow')">
                <el-table-column
                :label="$locale('movie.lateShow')"
                align="center"
              >
                <el-table-column
                  prop="lateShow.visitor"
                  :label="$locale('cashierReport.dialog.th.cashQty')"
                  width="50"
                  align="right"
                ></el-table-column>
                <el-table-column
                  prop="lateShow.total"
                  :label="$locale('trans.other.price')"
                  width="90"
                  align="right"
                  :formatter="priceFormatter_fn"
                ></el-table-column>
                </el-table-column>
              </template>
              <template v-if="getIsExistBoxOffice('morningShow')">
                <el-table-column
                :label="$locale('movie.morningShow')"
                align="center"
              >
                <el-table-column
                  prop="morningShow.visitor"
                  :label="$locale('cashierReport.dialog.th.cashQty')"
                  width="50"
                  align="right"
                ></el-table-column>
                <el-table-column
                  prop="morningShow.total"
                  :label="$locale('trans.other.price')"
                  width="90"
                  align="right"
                  :formatter="priceFormatter_fn"
                ></el-table-column>
                </el-table-column>
              </template>
              <template v-if="getIsExistBoxOffice('allNight')">
                <el-table-column
                  :label="$locale('movie.allNight')"
                  align="center"
                >
                  <el-table-column
                    prop="allNight.visitor"
                    :label="$locale('cashierReport.dialog.th.cashQty')"
                    width="50"
                    align="right"
                  ></el-table-column>
                  <el-table-column
                    prop="allNight.total"
                    :label="$locale('trans.other.price')"
                    width="90"
                    align="right"
                    :formatter="priceFormatter_fn"
                  ></el-table-column>
                </el-table-column>
              </template>
              <template v-if="getIsExistBoxOffice('special')">
                <el-table-column
                :label="$locale('movie.specialBusiness')"
                align="center"
              >
                <el-table-column
                  prop="special.visitor"
                  :label="$locale('cashierReport.dialog.th.cashQty')"
                  width="50"
                  align="right"
                ></el-table-column>
                <el-table-column
                  prop="special.total"
                  :label="$locale('trans.other.price')"
                  width="90"
                  align="right"
                  :formatter="priceFormatter_fn"
                ></el-table-column>
                </el-table-column>
              </template>
              <!-- BoxOfficeTypeTotal -->
              <el-table-column
                :label="$locale('cashierReport.dialog.total')"
                min-width="100"
                width="100"
                align="center"
                v-if="getIsExistBoxOffice('boxOffice') ||
                  getIsExistBoxOffice('lateShow') ||
                  getIsExistBoxOffice('morningShow') ||
                  getIsExistBoxOffice('allNight') ||
                  getIsExistBoxOffice('special')"
              >
                <!-- <template slot-scope="scope">{{ getTotalPrice(scope.row, "boxOffice")}}</template> -->
                <el-table-column
                  label="合計.枚数"
                  width="100"
                  align="right"
                  prop="total.visitor"
                ></el-table-column>
                <el-table-column
                  label="合計.金額"
                  width="100"
                  align="right"
                  prop="total.total"
                  :formatter="priceFormatter_fn"
                ></el-table-column>
              </el-table-column>
              <el-table-column :label="$locale('couponLib.theaterAdvTicket')">
                <el-table-column
                  prop="advanceTicket.visitor"
                  :label="$locale('cashierReport.dialog.th.cashQty')"
                  align="right"
                  width="50"
                ></el-table-column>
                <el-table-column
                  prop="advanceTicket.total"
                  :label="$locale('trans.other.price')"
                  align="right"
                  width="90"
                  :formatter="priceFormatter_fn"
                ></el-table-column>
              </el-table-column>
              <el-table-column :label="$locale('cashierReport.dialog.nationalTicket')" align="center">
                <el-table-column
                  prop="nationalTicket.visitor"
                  :label="$locale('cashierReport.dialog.th.cashQty')"
                  min-width="50"
                  width="50"
                  align="right"
                ></el-table-column>
                <el-table-column
                  prop="nationalTicket.total"
                  :label="$locale('trans.other.price')"
                  :formatter="priceFormatter_fn"
                  min-width="90"
                  width="90"
                  align="right"
                ></el-table-column>
              </el-table-column>
              <!-- couponTotal -->
              <el-table-column

                :label="$locale('cashierReport.dialog.total')"
                min-width="90"
                width="90"
                align="right"
              >
                <template slot-scope="scope">{{ getTotalPrice(scope.row, "coupon")}}</template>
              </el-table-column>
              <el-table-column :label="$locale('trans.box.cumulativeDevelopment')" align="center" v-if="selectLabels.includes('cumulativeDevelopment')">
                <el-table-column :label="$locale('operation.NAT.qty')" prop="accumulated.num" align="right" min-width="70" width="70"></el-table-column>
                <el-table-column :label="$locale('global.amount')" prop="accumulated.price" align="right" :formatter="priceFormatter_fn" min-width="120" width="120"></el-table-column>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>

        <!-- <el-row>
          <el-col :span="10" class="custom-border-table ticket-table" v-if="!isShowDetail">
            <el-table :data="tableData2" class="egl-table list-table" border>
              <template v-if="tableData2.length > 0">
                <el-table-column v-for="(keyName, i) in advanceTypeArr" :key="i" :label="advanceTypeText[keyName]">
                  <el-table-column label="枚数" width="100">
                    <template slot-scope="scope">
                      <span v-if="tableData2[scope.$index].advanceTypeMsg[i].num == 0">/</span>
                      <span v-else>{{ tableData2[scope.$index].advanceTypeMsg[i].num }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column :label="$locale('global.amount')" width="200">
                    <template slot-scope="scope">
                      <span v-if="tableData2[scope.$index].advanceTypeMsg[i].price == 0">/</span>
                      <span v-else>{{ tableData2[scope.$index].advanceTypeMsg[i].price }}</span>
                    </template>
                  </el-table-column>
                </el-table-column>
              </template>
              <el-table-column label="合計" prop="lineTotal" align="center"></el-table-column>
            </el-table>
            <el-table :data="tableData2" class="egl-table list-table" border>
              <el-table-column :label="$locale('couponLib.theaterAdvTicket')">
                <el-table-column
                  prop="advanceTicket.visitor"
                  :label="$locale('cashierReport.dialog.th.cashQty')"
                  min-width="100"
                ></el-table-column>
                <el-table-column
                  prop="advanceTicket.total"
                  :label="$locale('trans.other.price')"
                  min-width="140"
                  :formatter="priceFormatter_fn"
                ></el-table-column>
              </el-table-column>
              <el-table-column :label="$locale('cashierReport.dialog.nationalTicket')">
                <el-table-column
                  prop="nationalTicket.visitor"
                  :label="$locale('cashierReport.dialog.th.cashQty')"
                  min-width="100"
                ></el-table-column>
                <el-table-column
                  prop="nationalTicket.total"
                  :label="$locale('trans.other.price')"
                  :formatter="priceFormatter_fn"
                  min-width="140"
                ></el-table-column>
              </el-table-column>
              <el-table-column :label="$locale('global.total')" prop="total" :formatter="priceFormatter_fn" min-width="140"></el-table-column>
            </el-table>
          </el-col>
          <el-col :span="6" :offset="1" class="custom-border-table" v-if="!isShowDetail">
            <el-table :data="tableData3" class="egl-table list-table">
              <el-table-column :label="$locale('trans.box.cumulativeDevelopment')" align="center">
                <el-table-column :label="$locale('operation.NAT.qty')" prop="num" align="center"></el-table-column>
                <el-table-column :label="$locale('global.amount')" prop="price" align="center" :formatter="priceFormatter_fn"></el-table-column>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row> -->

        <!-- <div class="table-box film-table" v-if="!isShowDetail">
          <el-table :data="tableData1.tableData" class="egl-table" :span-method="mergeSpan">
            <el-table-column prop="filmName" width="300">
              <template slot="header">
                <el-dropdown :hide-on-click="false">
                  <span class="el-dropdown-link">
                    作品名<i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item
                      v-for="(text, index) in tableData1.checkbox.filmName"
                      :key="index"
                    >
                      <el-checkbox
                        :checked="true"
                        @change="
                          val => tableHeaderFilter(val, 'filmName', index)
                        "
                      >
                        {{ text }}
                      </el-checkbox>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
            </el-table-column>
            <el-table-column width="168">
              <template slot="header">
                <el-dropdown :hide-on-click="false">
                  <span class="el-dropdown-link">
                    スクリーン規格<i
                      class="el-icon-arrow-down el-icon--right"
                    ></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item
                      v-for="(text, index) in tableData1.checkbox.version"
                      :key="index"
                    >
                      <el-checkbox
                        :checked="true"
                        @change="
                          val => tableHeaderFilter(val, 'version', index)
                        "
                      >
                        {{ text }}
                      </el-checkbox>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
              <template slot-scope="scope">
                <span v-if="typeof scope.row.version == 'string'">{{
                  scope.row.version
                }}</span>
                <span v-else>{{ scope.row.version.toString() }}</span>
              </template>
            </el-table-column>
            <el-table-column width="160">
              <template slot="header">
                <el-dropdown :hide-on-click="false">
                  <span class="el-dropdown-link">
                    字幕/吹替<i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item
                      v-for="(text, index) in tableData1.checkbox
                        .subtitlesVersion"
                      :key="index"
                    >
                      <el-checkbox
                        :checked="true"
                        @change="
                          val =>
                            tableHeaderFilter(val, 'subtitlesVersion', index)
                        "
                      >
                        {{ text }}
                      </el-checkbox>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
              <template slot-scope="scope">
                <span v-if="typeof scope.row.subtitlesVersion == 'string'">{{
                  scope.row.subtitlesVersion
                }}</span>
                <span v-else>{{ scope.row.subtitlesVersion.toString() }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="otherVersion" width="160">
              <template slot="header">
                <el-dropdown :hide-on-click="false">
                  <span class="el-dropdown-link">
                    その他バージョン<i
                      class="el-icon-arrow-down el-icon--right"
                    ></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item
                      v-for="(text, index) in tableData1.checkbox.otherVersion"
                      :key="index"
                    >
                      <el-checkbox
                        :checked="true"
                        @change="
                          val => tableHeaderFilter(val, 'otherVersion', index)
                        "
                      >
                        {{ text }}
                      </el-checkbox>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
              <template slot-scope="scope">
                <span v-if="typeof scope.row.otherVersion == 'string'">{{
                  scope.row.otherVersion
                }}</span>
                <span v-else>{{ scope.row.otherVersion.toString() }}</span>
              </template>
            </el-table-column>
            <el-table-column label="公開周" prop="week" width="200"></el-table-column>
            <el-table-column label="配給" prop="distributor" width="200"></el-table-column>
            <template v-if="tableData1.tableData.length > 0">
              <el-table-column v-for="(text, i) in ticketNameArr" :key="i" :label="text">
                <el-table-column label="枚数" width="100">
                  <template slot-scope="scope">
                    <span
                      v-if="
                        tableData1.tableData[scope.$index].ticketMsg[i].num == 0
                      "
                      >/</span
                    >
                    <span v-else>{{
                      tableData1.tableData[scope.$index].ticketMsg[i].num
                    }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="金額" width="200">
                  <template slot-scope="scope">
                    <span
                      v-if="
                        tableData1.tableData[scope.$index].ticketMsg[i].price ==
                          0
                      "
                      >/</span
                    >
                    <span v-else>{{
                      tableData1.tableData[scope.$index].ticketMsg[i].price
                    }}</span>
                  </template>
                </el-table-column>
              </el-table-column>
            </template>
            <el-table-column label="合計" width="200" prop="lineTotal"></el-table-column>
          </el-table>
        </div> -->

        <!-- <div class="table-box ticket-table" v-if="!isShowDetail">
          <el-table :data="tableData2" class="egl-table">
            <template v-if="tableData2.length > 0">
              <el-table-column v-for="(keyName, i) in advanceTypeArr" :key="i" :label="advanceTypeText[keyName]">
                <el-table-column label="枚数" width="100">
                  <template slot-scope="scope">
                    <span
                      v-if="tableData2[scope.$index].advanceTypeMsg[i].num == 0"
                      >/</span
                    >
                    <span v-else>{{
                      tableData2[scope.$index].advanceTypeMsg[i].num
                    }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="金額" width="200">
                  <template slot-scope="scope">
                    <span
                      v-if="
                        tableData2[scope.$index].advanceTypeMsg[i].price == 0
                      "
                      >/</span
                    >
                    <span v-else>{{
                      tableData2[scope.$index].advanceTypeMsg[i].price
                    }}</span>
                  </template>
                </el-table-column>
              </el-table-column>
            </template>
            <el-table-column label="合計" width="200" prop="lineTotal"></el-table-column>
          </el-table>
        </div> -->

        <!-- <div class="table-box" v-if="!isShowDetail">
          <el-table :data="tableData3" class="egl-table">
            <el-table-column label="累計興収">
              <el-table-column label="枚数" prop="num" width="100"></el-table-column>
              <el-table-column label="金額" prop="price" width="200"></el-table-column>
            </el-table-column>
          </el-table>
        </div> -->
        <div id="print">
          <div class="custom-border-table boxOffice" v-if="isShowDetail">
                <el-table :data="tableData4" class="egl-table list-table boxDetail" :span-method="merge4arrayMethod">
                  <el-table-column :label="$locale('global.titleOfWork')" prop="filmName" width="300"></el-table-column>
                  <el-table-column :label="$locale('global.screenStandard')" prop="version" width="80"></el-table-column>
                  <el-table-column :label="$locale('trans.report.version.caption')" prop="subtitlesVersion" width="80"></el-table-column>
                  <el-table-column :label="$locale('global.otherVersions')" prop="otherVersion" width="80" v-if="tableData4.some(item => item.otherVersion)"></el-table-column>
                  <el-table-column :label="$locale('report.preSalesDaily.grouping')" prop="ticketRuleName" width="140"></el-table-column>

                  <el-table-column :label="$locale('global.sale')" prop="platform" width="100"></el-table-column>
                  <el-table-column :label="$locale('couponLib.ticketType')" prop="ticketTypeName" width="200" align="right"></el-table-column>
                  <!-- <el-table-column :label="$locale('trans.box.coupon')" width="200">
                    <template slot-scope="scope">
                      <span v-if="scope.row.coupon > 0">{{ scope.row.coupon }}</span>
                      <span>/</span>
                    </template>
                  </el-table-column> -->
                  <el-table-column :label="$locale('trans.box.coupon')" prop="coupon" width="135"></el-table-column>
                  <el-table-column :label="$locale('trans.box.admissionFee')" prop="price" width="80" :formatter="boxDetailFormatter" align="right"></el-table-column>
                  <el-table-column :label="houseName">
                    <el-table-column :label="$locale('operation.NAT.qty')" prop="num" width="50" :formatter="boxDetailFormatter" align="right"></el-table-column>
                    <el-table-column :label="$locale('global.amount')" prop="lineTotal" width="80" :formatter="boxDetailFormatter" align="right"></el-table-column>
                  </el-table-column>
                </el-table>
                <!-- <div class="custom-border-table">
                  <el-table :data="tableData5" class="egl-table list-table" :span-method="tb5_mergeSpan">
                    <el-table-column :label="$locale('global.sale')" prop="platform" width="100"></el-table-column>
                    <el-table-column :label="$locale('trans.box.admissionFee')" prop="price" width="100"></el-table-column>
                    <el-table-column :label="$locale('operation.NAT.qty')" prop="num" width="100"></el-table-column>
                    <el-table-column :label="$locale('global.amount')" prop="lineTotal" width="200"></el-table-column>
                  </el-table>
                </div> -->
          </div>
        </div>
      </div>
      </div>
      
    </div>
  <!-- </div> -->
</template>

<script>
import { mapState } from "vuex";
import "@/assets/style/boxOfficeDaily.less";
import { getDailyMovieRevenueReport, getDailyMovieRevenueReportV2, getDailyScheduleRevenueReport, getFilmList } from "@/helpers/service/api/report";
import { getVersion, getOtherVersion } from "@/helpers/service/api/common";
// import DatePickerGroup from "@/components/DatePickerGroup";
import DatePickerGroup from "@/components/common/CommDatePickerGroup/DatePickerGroup.vue";
import { toThousands } from "@/utils/common";
import { sortBy, intersection, keys } from "lodash";
import json2csv from "json2csv";
import { json2csv_fn } from '@/utils/common';
import { getExportName_fn } from '@/utils/common'
import { weekLocaleArray } from "@/utils/common";

import { columnLabels } from '@/assets/js/boxOfficeDaily.js'
import { setStorageModule_fn } from '@/utils/common.js'

// import filterOptions from "@/mixins/filterOptions";
// import { localStorage } from '@/utils/localStorage'
// import { saveFilterOptions } from "@/utils/filterOptions";


export default {
  name: "BoxOfficeDaily",
  // mixins: [ filterOptions ],
  data() {
    return {
      printObj: {
        popTitle: this.$locale("sideMenu.reports.box"),
        id: "print",
      },
      onSearch: {
        startDate: 0,
        endDate: 0,
      },
      filter: {
        startDate: 0,
        endDate: 0,
      },
      searchTime: "",
      endTimePickerOptions: {
        disabledDate: this.endTimeDisableDate
      },
      startTimePickerOptions: {
        disabledDate: this.startTimeDisableDate
      },
      advanceTypeText: {
        "NONE": "普通票",
        "NATIONWIDE": "全国共通券",
        "PRE_SALES": "劇場前売券",
        "COMMON": "共通券",
        "INVITATION": "招待券",
      },
      apiData: [],
      tableData_original: [],
      tableData1_original: [],
      tableData1: {
        tableData: [],
        checkbox: {},
        checkboxVal: {}
      },
      ticketNameArr: [],
      advanceTypeArr: [],
      tableData2: [],
      tableData3: [],
      checkboxGroup: [],
      showRule: {
        movie: "",
        scheduleTime: "",
        schedule: "",
        coupon: [
          "notUseCoupon",
          "showDetail",
          "displayUnitPriceZero"
        ],
        mobilization: [
          "freeMobilize",
          "adjustMobilize"
        ],
      },
      mobilization: [
        "freeMobilize",
        "adjustMobilize"
      ],
      tableData4: [],
      tableData5: [],
      allFilmOption: [],
      allSchedleOption: [],
      scheduleTimeOption: [],
      scheduleOption: [],
      scheduleTime: "",
      cinemaName: "",
      brandName: "",
      houseName: "",
      searchTimeDetail: "",
      isShowDetail: false,
      spanArr: [],
      pos: 0,
      filterTypes: {
        films: [],
        versions: [],
        subtitlesVersions: [
          {
            text: "ない",
            value: "ない"
          },
          {
            text: "字幕",
            value: "字幕"
          },
          {
            text: "吹替",
            value: "吹替"
          },
        ],
        otherVersions: [],
      },
      filterValues : {
        films: [],
        versions: [],
        subtitlesVersions: ["ない", "字幕", "吹替"],
        otherVersions: [],
      },
      selectLabels: ['version', 'subtitlesVersion', 'otherVersion', 'week', 'clientName', 'cumulativeDevelopment'],
      columnLabels,
      weekLocaleArray,
    };
  },
  methods: {
    getScheduleFormatTimeText(item) {
      return item.status === "delete" ? `${this.getScheduleFormatTime(item.startTime)} ~ ${this.getScheduleFormatTime(item.endTime)} (削除済み)`:
        `${this.getScheduleFormatTime(item.startTime)} ~ ${this.getScheduleFormatTime(item.endTime)}`
    },
    exportCSV_fn() {
      let csvData = [];
      const fieldsBase = [
        {//0
          label: this.$locale("global.titleOfWork"),
          value: "filmName",
        },
        // {//1
        //   label: this.$locale("global.screenStandard"),
        //   value: "version",
        // },
        // {//2
        //   label: this.$locale("trans.report.version.caption"),
        //   value: "subtitlesVersion",
        // },
        // {//3
        //   label: this.$locale("global.otherVersions"),
        //   value: "otherVersion",
        // },
        // {//4
        //   label: this.$locale("trans.box.week"),
        //   value: "week",
        // },
        // {//5
        //   label: this.$locale("trans.box.clientName"),
        //   value: "clientName",
        // },
        // {
        //   label: this.$locale("cashierReport.dialog.total"),
        //   value: "total"
        // },
        {
          label: this.$locale("couponLib.theaterAdvTicket") + this.$locale("cashierReport.dialog.th.cashQty"),
          value: "advanceCouponVistor"
        },
        {
          label: this.$locale("couponLib.theaterAdvTicket") + this.$locale("trans.other.price"),
          value: "advanceCouponTotal"
        },
        {
          label: this.$locale("cashierReport.dialog.nationalTicket") + this.$locale("cashierReport.dialog.th.cashQty"),
          value: "nationalTicketVistor"
        },
        {
          label: this.$locale("cashierReport.dialog.nationalTicket") + this.$locale("trans.other.price"),
          value: "nationalTicketTotal"
        },
        {
          label: this.$locale("cashierReport.dialog.total"),
          value: "ticketTotal"
        },
        // {
        //   label: this.$locale("trans.box.cumulativeDevelopment") + this.$locale("cashierReport.dialog.th.cashQty"),
        //   value: "accuVistor"
        // },
        // {
        //   label: this.$locale("trans.box.cumulativeDevelopment") + this.$locale("trans.other.price"),
        //   value: "accuTotal"
        // },
      ];
      if (this.selectLabels.includes('version')) {
        const index = fieldsBase.findIndex(item => item.value === 'advanceCouponVistor')
        fieldsBase.splice(index, 0, {
          label: this.$locale("global.screenStandard"),
          value: "version",
        })
      }
      if (this.selectLabels.includes('subtitlesVersion')) {
        const index = fieldsBase.findIndex(item => item.value === 'advanceCouponVistor')
        fieldsBase.splice(index, 0, {
          label: this.$locale("trans.report.version.caption"),
          value: "subtitlesVersion",
        })
      }
      if (this.selectLabels.includes('otherVersion')) {
        const index = fieldsBase.findIndex(item => item.value === 'advanceCouponVistor')
        fieldsBase.splice(index, 0, {
          label: this.$locale("global.otherVersions"),
          value: "otherVersion",
        })
      }
      if (this.selectLabels.includes('week')) {
        const index = fieldsBase.findIndex(item => item.value === 'advanceCouponVistor')
        fieldsBase.splice(index, 0, {
          label: this.$locale("trans.box.week"),
          value: "week",
        })
      }
      if (this.selectLabels.includes('clientName')) {
        const index = fieldsBase.findIndex(item => item.value === 'advanceCouponVistor')
        fieldsBase.splice(index, 0, {
          label: this.$locale("trans.box.clientName"),
          value: "clientName",
        })
      }
      if (this.selectLabels.includes('cumulativeDevelopment')) {
        fieldsBase.push({
          label: this.$locale("trans.box.cumulativeDevelopment") + this.$locale("cashierReport.dialog.th.cashQty"),
          value: "accuVistor"
        })
        fieldsBase.push({
          label: this.$locale("trans.box.cumulativeDevelopment") + this.$locale("trans.other.price"),
          value: "accuTotal"
        })
      }
      let fields = [ ...fieldsBase ];
      const fieldsExt = [
        {//0
          label: this.$locale("movie.mainBusiness") + this.$locale("cashierReport.dialog.th.cashQty"),
          value: "boxOfficeVistor"
        },
        {//1
          label: this.$locale("movie.mainBusiness") + this.$locale("trans.other.price"),
          value: "boxOfficeTotal"
        },
        {//2
          label: this.$locale("movie.lateShow") + this.$locale("cashierReport.dialog.th.cashQty"),
          value: "lateShowVistor"
        },
        {//3
          label: this.$locale("movie.lateShow") + this.$locale("trans.other.price"),
          value: "lateShowTotal"
        },
        {//4
          label: this.$locale("movie.morningShow") + this.$locale("cashierReport.dialog.th.cashQty"),
          value: "morningShowVistor"
        },
        {//5
          label: this.$locale("movie.morningShow") + this.$locale("trans.other.price"),
          value: "morningShowTotal"
        },
        {//6
          label: this.$locale("movie.allNight") + this.$locale("cashierReport.dialog.th.cashQty"),
          value: "allNightVistor"
        },
        {//7
          label: this.$locale("movie.allNight") + this.$locale("trans.other.price"),
          value: "allNightTotal"
        },
        {//8
          label: this.$locale("movie.specialBusiness") + this.$locale("cashierReport.dialog.th.cashQty"),
          value: "specialVistor"
        },
        {//9
          label: this.$locale("movie.specialBusiness") + this.$locale("trans.other.price"),
          value: "specialTotal"
        },
        {//10
          label: '合計.枚数',
          value: "boxOfficeVisitorTotal"
        },
        {//11
          label: '合計.金額',
          value: "boxOfficeAmountTotal"
        },
      ];
      let _addCols = [];

      if (this.getIsExistBoxOffice("boxOffice")) {
        _addCols.push(fieldsExt[0]);
        _addCols.push(fieldsExt[1]);
      }

      if (this.getIsExistBoxOffice("lateShow")) {
        _addCols.push(fieldsExt[2]);
        _addCols.push(fieldsExt[3]);
      }

      if (this.getIsExistBoxOffice("morningShow")) {
        _addCols.push(fieldsExt[4]);
        _addCols.push(fieldsExt[5]);
      }

      if (this.getIsExistBoxOffice("allNight")) {
        _addCols.push(fieldsExt[6]);
        _addCols.push(fieldsExt[7]);
      }

      if (this.getIsExistBoxOffice("special")) {
        _addCols.push(fieldsExt[8]);
        _addCols.push(fieldsExt[9]);
      }
      if (
        this.getIsExistBoxOffice("boxOffice") ||
        this.getIsExistBoxOffice("lateShow") ||
        this.getIsExistBoxOffice("morningShow") ||
        this.getIsExistBoxOffice("allNight") ||
        this.getIsExistBoxOffice("special")
      ) {
        _addCols.push(fieldsExt[10]);
        _addCols.push(fieldsExt[11]);
      }
      
      fields.splice((this.selectLabels.filter(str => str !== "cumulativeDevelopment").length) + 1, 0, ..._addCols);

      // let advanceCouponVistorTotal = 0;
      // let advanceCouponTotal = 0;
      // let nationalTicketVistorTotal = 0;
      // let nationalTicketTotal = 0;
      // let accuVistorTotal = 0;
      // let accuTotal = 0;
      // this.tableData2.forEach(item => {
      //   advanceCouponVistorTotal += item.advanceTicket.visitor;
      //   advanceCouponTotal += item.advanceTicket.total;
      //   nationalTicketVistorTotal += item.nationalTicket.visitor;
      //   nationalTicketTotal += item.nationalTicket.total;
      // });
      // this.tableData3.forEach(item => {
      //   accuVistorTotal += item.num;
      //   accuTotal += item.price;
      // });
      function formatTotal(total) {
        return isNaN(total) ? 0 : total;
      }
      this.tableData1.tableData.forEach(item => {
        csvData.push({
          filmName: item.filmName,
          ...this.selectLabels.includes('clientName') ? { clientName: item.clientName } : {},
          ...this.selectLabels.includes('week') ? { week: item.week } : {},
          ...this.selectLabels.includes('version') ? { version: item.version } : {},
          ...this.selectLabels.includes('subtitlesVersion') ? { subtitlesVersion: item.subtitlesVersion } : {},
          ...this.selectLabels.includes('otherVersion') ? { otherVersion: item.otherVersion } : {},
          allNightVistor: item.allNight.visitor,
          allNightTotal: item.allNight.total,
          boxOfficeVistor: item.boxOffice.visitor,
          boxOfficeTotal: item.boxOffice.total,
          lateShowVistor: item.lateShow.visitor,
          lateShowTotal: item.lateShow.total,
          morningShowVistor: item.morningShow.visitor,
          morningShowTotal: item.morningShow.total,
          specialVistor: item.special.visitor,
          specialTotal: item.special.total,
          // total: formatTotal(item.allNight.total) + formatTotal(item.boxOffice.total) + formatTotal(item.lateShow.total)
          // + formatTotal(item.morningShow.total) + formatTotal(item.special.total),
          boxOfficeVisitorTotal: formatTotal(item.allNight.visitor) + formatTotal(item.boxOffice.visitor) + formatTotal(item.lateShow.visitor)
          + formatTotal(item.morningShow.visitor) + formatTotal(item.special.visitor),
          boxOfficeAmountTotal: formatTotal(item.allNight.total) + formatTotal(item.boxOffice.total) + formatTotal(item.lateShow.total)
          + formatTotal(item.morningShow.total) + formatTotal(item.special.total),
          advanceCouponVistor: item.advanceTicket.visitor,
          advanceCouponTotal: item.advanceTicket.total,
          nationalTicketVistor: item.nationalTicket.visitor,
          nationalTicketTotal: item.nationalTicket.total,
          ticketTotal: item.advanceTicket.total + item.nationalTicket.total,
          ...this.selectLabels.includes('cumulativeDevelopment') ? { accuVistor: item.accumulated.num } : {},
          ...this.selectLabels.includes('cumulativeDevelopment') ? { accuTotal: item.accumulated.price } : {},
        });
      });
      json2csv_fn(csvData, fields, 
      // this.$moment().format("YYYYMMDDHHmm") + "_" + this.$locale("sideMenu.reports.box")
      getExportName_fn(
        this.$locale("sideMenu.reports.box"),
        '',
        '',
        '',
        `${this.$moment(this.filter.startDate).format('YYYY-MM-DD')} （${weekLocaleArray[this.$moment(this.filter.startDate).day()]}${this.$locale("calendar.weekday")}）~ ${this.$moment(this.filter.endDate).format('YYYY-MM-DD')} （${weekLocaleArray[this.$moment(this.filter.endDate).day()]}${this.$locale("calendar.weekday")}）`,
        this.cinemaName,
        this.$moment().format('YYYYMMDDHHmm')
      )
      );
      // try {
      //   const result = json2csv.parse(csvData, {
      //     fields
      //   });
      //   let csvContent = "data:text/csv;charset=utf-8,\uFEFF" + result;
      //   let link = document.createElement("a");
      //   link.href = encodeURI(csvContent);
      //   link.download = `${this.$moment().format("YYYYMMDDHHmm")}_${this.$locale("sideMenu.reports.box") + ".csv"}`;
      //   document.body.appendChild(link);
      //   link.click();
      //   document.body.removeChild(link);
      // } catch(err) {
      //   alert(err);
      // }
    },
    getDate(obj) {
      this.filter = {
        startDate: obj.startDate,
        endDate: obj.endDate,
      };
    },
    endTimeDisableDate(time) {
      return (
        time.getTime() > Date.now() ||
        time.getTime() < this.$moment(this.filter.startDate).valueOf()
      );
    },
    startTimeDisableDate(time) {
      return time.getTime() > this.$moment(this.filter.endDate).valueOf();
    },
    mergeSpan({ rowIndex, columnIndex }) {
      if (rowIndex == this.tableData1.tableData.length - 1 && columnIndex == 0) {
        return {
          rowspan: 1,
          colspan: 6,
        };
      } else if (rowIndex == this.tableData1.tableData.length - 1 && columnIndex < 6) {
        return {
          rowspan: 1,
          colspan: 0,
        };
      }
    },
    getCurDay(num = "", keyName) {
      const today = this.$moment().valueOf();
      let newFilter = { ...this.filter };
      let day = "";

      if (num == "") {
        day = this.$moment(newFilter[keyName]).valueOf();
      } else {
        day = this.$moment(newFilter[keyName])
          .subtract(-num, "days")
          .valueOf();
      }

      newFilter[keyName] = day;

      newFilter.endDate =
        newFilter.endDate < newFilter.startDate
          ? newFilter.startDate
          : newFilter.endDate;
      newFilter.endDate = newFilter.endDate > today ? today : newFilter.endDate;
      newFilter.startDate =
        newFilter.startDate > newFilter.endDate
          ? newFilter.endDate
          : newFilter.startDate;

      this.filter = { ...newFilter };
    },
    search_fn() {
      const that = this;
      let { cinemaObj } = this;
      let cinemaName = "";

      if (this.cinemaId != "") {
        cinemaObj = JSON.parse(cinemaObj);
        for (let i = 0; i < cinemaObj.length; i++) {
          if (cinemaObj[i].id == this.cinemaId) {
            cinemaName = cinemaObj[i].name;
            break;
          }
        }

        this.cinemaName = cinemaName;
      }

      if (this.cinemaId == "") {
        this.$emit("callCinema", "search_fn");

        return;
      }

      let obj = {
        ...that.onSearch,
        ...that.filter,
      };

      that.onSearch = { ...obj };

      getDailyMovieRevenueReportV2({
        cinemaId: this.cinemaId,
        startDate: that.$moment(obj.startDate).format("YYYY-MM-DD"),
        endDate: that.$moment(obj.endDate).format("YYYY-MM-DD"),
        version: that.checkboxGroup.indexOf("version") > -1,
        subtitlesVersion: that.checkboxGroup.indexOf("subtitlesVersion") > -1,
        otherVersion: that.checkboxGroup.indexOf("otherVersion") > -1
      }).then(res => {
        const filmKeyName = ["filmName", "version", "subtitlesVersion", "otherVersion"];
        let initData = that.formatTableData(res.data.dmrreportRecords, filmKeyName);
        let tableData = this.getTableData_fn(initData.tableData, initData.ticketNameArr, initData.advanceTypeArr);

        that.apiData = res.data.dmrreportRecords;

        const showData = that.getTableLastLine(tableData, initData.ticketNameArr, initData.advanceTypeArr);

        that.brandName = res.data.brandName;
        that.allFilmOption = initData.allFilmOption;
        that.allSchedleOption = initData.allSchedleOption;
        that.scheduleOption = initData.allSchedleOption;
        that.ticketNameArr = initData.ticketNameArr;
        that.advanceTypeArr = initData.advanceTypeArr;
        that.tableData_original = tableData;

        [that.tableData1.tableData, that.tableData2, that.tableData3] = showData;
        that.tableData1 = {
          // tableData: showData[0],
          checkbox: initData.checkbox,
          checkboxVal: initData.checkbox,
        };
        // that.tableData2 = showData[1];
        // that.tableData3 = showData[2];
        that.searchTime = that.$moment().format("YYYY-MM-DD hh:mm:ss");

        if (that.checkboxGroup.length > 0) {
          that.groupFilter();
        }
      });
    },
    formatTableData(data, filters = []) {
      const that = this;
      let obj = {
        tableData: []
      };
      let ticketNameArr = [];
      let advanceTypeArr = [];
      let checkbox = {};
      let filmCacheArr = [];
      let allFilmOption = [];
      let filmOptonObj = {};
      let allSchedleOption = [];
      let scheduleOptionObj = {};

      filters.map(keyName => {
        checkbox[keyName] = [];
      });

      data.map(dataItem => {
        let filmMsg = {
          filmId: dataItem.filmId,
          filmName: dataItem.filmName,
          version: dataItem.version,
          subtitlesVersion: dataItem.subtitlesVersion,
          otherVersion: dataItem.otherVersion
        };
        let filmMsg_str = JSON.stringify(filmMsg);
        let dataIndex = filmCacheArr.indexOf(filmMsg_str);

        if (dataIndex < 0) {
          filmCacheArr.push(filmMsg_str);
          obj.tableData.push({
            ...filmMsg,
            week: dataItem.week,
            distributor: [ dataItem.distributor ],
            ticketMsg: [
              {
                name: dataItem.ticketRuleName,
                price: dataItem.ticketTypePrice - dataItem.couponPrice
              }
            ],
            advanceTypeMsg: [
              {
                name: dataItem.advanceType,
                price: dataItem.ticketTypePrice - dataItem.couponPrice
              }
            ]
          });
        } else {
          obj.tableData[dataIndex] = {
            ...obj.tableData[dataIndex],
            week: dataItem.week > obj.tableData[dataIndex].week ? dataItem.week : obj.tableData[dataIndex].week,
            distributor: [...obj.tableData[dataIndex].distributor, dataItem.distributor],

            ticketMsg: [
              ...obj.tableData[dataIndex].ticketMsg,
              {
                name: dataItem.ticketRuleName,
                price: dataItem.ticketTypePrice - dataItem.couponPrice
              }
            ],
            advanceTypeMsg: [
              ...obj.tableData[dataIndex].advanceTypeMsg,
              {
                name: dataItem.advanceType,
                price: dataItem.ticketTypePrice - dataItem.couponPrice
              }
            ]
          };
        }

        filters.map(keyName => {
          if (typeof dataItem[keyName] == "string") {
            if (checkbox[keyName].indexOf(dataItem[keyName]) < 0) {
              checkbox[keyName].push(dataItem[keyName]);
            }
          } else {
            dataItem[keyName].map(dataItemKeyVal => {
              if (checkbox[keyName].indexOf(dataItemKeyVal) < 0) {
                checkbox[keyName].push(dataItemKeyVal);
              }
            });
          }
        });

        if (ticketNameArr.indexOf(dataItem.ticketRuleName) < 0) {
          ticketNameArr.push(dataItem.ticketRuleName);
        }

        if (advanceTypeArr.indexOf(dataItem.advanceType) < 0) {
          advanceTypeArr.push(dataItem.advanceType);
        }

        if (!scheduleOptionObj[dataItem.scheduleId]) {
          scheduleOptionObj[dataItem.scheduleId] = {
            scheduleId: dataItem.scheduleId,
            time: that.$moment(dataItem.scheduleStartTime).format("YYYY-MM-DD hh:mm")  + " ~ " + that.$moment(dataItem.scheduleEndTime).format("hh:mm"),
            filmId: dataItem.filmId,
          };
        }

        if (!filmOptonObj[dataItem.filmId]) {
          filmOptonObj[dataItem.filmId] = {
            filmId: dataItem.filmId,
            filmName: dataItem.filmName
          };
        }
      });

      Object.keys(filmOptonObj).map(filmId => {
        allFilmOption.push(filmOptonObj[filmId]);
      });

      Object.keys(scheduleOptionObj).map(scheduleId => {
        allSchedleOption.push(scheduleOptionObj[scheduleId]);
      });

      obj.checkbox = checkbox;
      obj.ticketNameArr = ticketNameArr;
      obj.advanceTypeArr = advanceTypeArr;
      obj.allSchedleOption = allSchedleOption;
      obj.allFilmOption = allFilmOption;

      return obj;
    },
    getTableData_fn(tableData = [], ticketNameArr = [], advanceTypeArr = []) {
      let newData = [];
      let tb1 = [];
      let tb2 = [];
      let tb3 = [];

      tableData.map(obj => {
        let newObj = { ...obj };
        let tb2Obj = {};
        let line_num = 0;
        let line_count = 0;

        newObj.distributor = [ ...new Set(obj.distributor) ];
        newObj.ticketMsg = [];

        ticketNameArr.map(text => {
          newObj.ticketMsg.push({
            name: text,
            num: 0,
            price: 0
          });
        });

        tb2Obj.advanceTypeMsg = [];
        advanceTypeArr.map(text => {
          tb2Obj.advanceTypeMsg.push({
            name: text,
            num: 0,
            price: 0
          });
        });

        obj.ticketMsg.map(ticketItem => {
          let ticketNameIndex = ticketNameArr.indexOf(ticketItem.name);

          newObj.ticketMsg[ticketNameIndex].num += 1;
          newObj.ticketMsg[ticketNameIndex].price += ticketItem.price;

          line_num++;
          line_count += ticketItem.price;

          newObj.lineTotal = line_count;
        });

        obj.advanceTypeMsg.map(item => {
          let advanceTypeIndex = advanceTypeArr.indexOf(item.name);

          tb2Obj.advanceTypeMsg[advanceTypeIndex].num += 1;
          tb2Obj.advanceTypeMsg[advanceTypeIndex].price += item.price;
        });

        tb1.push(newObj);
        tb2.push({
          ...tb2Obj,
          lineTotal: line_count
        });
        tb3.push({
          num: line_num,
          price: line_count
        });
      });

      newData[0] = tb1;
      newData[1] = tb2;
      newData[2] = tb3;
      return newData;
    },
    getTableLastLine(data, ticketNameArr = [], advanceTypeArr = []) {
      let [tb1, tb2, tb3] = [ ...data ];
      let tb1_last = {
        filmName: this.$locale("global.total"),
        ticketMsg: [],
        lineTotal: 0
      };
      let tb2_last = {
        advanceTypeMsg: [],
        lineTotal: 0
      };
      let tb3_last = {
        num: 0,
        price: 0
      };

      ticketNameArr.map(text => {
        tb1_last.ticketMsg.push({
          name: text,
          num: 0,
          price: 0
        });
      });
      tb1.map(obj => {
        obj.ticketMsg.map((item, i) => {
          tb1_last.ticketMsg[i].num = tb1_last.ticketMsg[i].num + item.num;
          tb1_last.ticketMsg[i].price =
            tb1_last.ticketMsg[i].price + item.price;
        });

        tb1_last.lineTotal = tb1_last.lineTotal + obj.lineTotal;
      });
      tb1.push(tb1_last);

      for (let i = 0; i < advanceTypeArr.length; i++) {
        tb2_last.advanceTypeMsg.push({
          name: advanceTypeArr[i],
          num: 0,
          price: 0
        });
      }
      tb2.map(obj => {
        obj.advanceTypeMsg.map((item, i) => {
          tb2_last.advanceTypeMsg[i].num =
            tb2_last.advanceTypeMsg[i].num + item.num;
          tb2_last.advanceTypeMsg[i].price =
            tb2_last.advanceTypeMsg[i].price + item.price;
        });

        tb2_last.lineTotal = tb2_last.lineTotal + obj.lineTotal;
      });

      tb2.push(tb2_last);

      tb3.map(obj => {
        tb3_last.num = tb3_last.num + obj.num;
        tb3_last.price = tb3_last.price + obj.price;
      });
      tb3.push(tb3_last);

      return [tb1, tb2, tb3];
    },
    tableHeaderFilter(val, keyName, index) {
      const that = this;
      let { checkbox, checkboxVal } = JSON.parse(JSON.stringify(this.tableData1));
      let search = {};
      let newData = [];
      const text = checkbox[keyName][index];
      const table_original = JSON.parse(JSON.stringify(that.tableData_original));

      if (val) {
        checkboxVal[keyName].push(text);
      } else {
        checkboxVal[keyName].splice(checkboxVal[keyName].indexOf(text), 1);
      }

      Object.keys(checkboxVal).map(keyName => {
        if (checkboxVal[keyName].length > 0) {
          search[keyName] = [ ...checkboxVal[keyName] ];
        } else {
          search[keyName] = [];
        }
      });

      for (let keyName in search) {
        if (checkbox[keyName].length == 0) {
          delete search[keyName];
        }
      }

      newData = this.filterData(table_original, search);
      newData = this.getTableLastLine(
        newData,
        this.ticketNameArr,
        this.advanceTypeArr
      );

      this.tableData1 = {
        // tableData: newData[0],
        checkbox: checkbox,
        checkboxVal: checkboxVal
      };
      // this.tableData2 = newData[1];
      // this.tableData3 = newData[2];

      [this.tableData1.tableData, this.tableData2, this.tableData3] = newData;
    },
    filterData(data = [], searchObj = {}) {
      let arr = [[], [], []];
      let [tb1, tb2, tb3] = data;
      let dataIndexAppear = [];
      let searchLength = Object.keys(searchObj).length;

      tb1.length--;
      for (let i = 0; i < tb1.length; i++) {
        dataIndexAppear.push(0);
      }

      tb1.map((obj, index) => {
        Object.keys(searchObj).map(keyName => {
          if (typeof obj[keyName] == "string") {
            if (searchObj[keyName].indexOf(obj[keyName]) >= 0) {
              dataIndexAppear[index]++;
            }
          } else {
            for (let i = 0; i < obj[keyName].length; i++) {
              if (searchObj[keyName].indexOf(obj[keyName][i]) >= 0) {
                dataIndexAppear[index]++;
                break;
              }
            }
          }
        });
      });

      for (let i = 0; i < tb1.length; i++) {
        if (dataIndexAppear[i] == searchLength) {
          arr[0].push(JSON.parse(JSON.stringify(tb1[i])));
          arr[1].push(JSON.parse(JSON.stringify(tb2[i])));
          arr[2].push(JSON.parse(JSON.stringify(tb3[i])));
        }
      }

      return arr;
    },
    groupFilter() {
      const that = this;
      const apiData = JSON.parse(JSON.stringify(that.apiData));

      let checkboxKeyName = [ ...that.checkboxGroup ];
      let group = {};
      const filmKeyName = ["filmName", "version", "subtitlesVersion", "otherVersion"];
      let newData = [];
      let initData = [];
      let tableData = [];
      let showData = [];
      const tableData1 = JSON.parse(JSON.stringify(that.tableData1));

      checkboxKeyName.map(keyName => {
        group[keyName] = [ ...that.tableData1.checkbox[keyName] ];
      });

      newData = that.mergeData(apiData, group);

      initData = that.formatTableData(newData, filmKeyName);
      tableData = this.getTableData_fn(
        initData.tableData,
        initData.ticketNameArr,
        initData.advanceTypeArr
      );

      that.tableData_original = tableData;

      if (
        JSON.stringify(tableData1.checkbox) !=
        JSON.stringify(tableData1.checkboxVal)
      ) {
        tableData = that.filterData(tableData, tableData1.checkboxVal);
      }

      showData = that.getTableLastLine(
        tableData,
        initData.ticketNameArr,
        initData.advanceTypeArr
      );

      // that.tableData_original = tableData;

      const [tData1, tData2, tData3] = showData;
      that.tableData1 = {
        ...that.tableData1,
        tableData: tData1
      };
      that.tableData2 = tData2;
      that.tableData3 = tData3;
    },
    mergeData(data, groups) {
      data.map(obj => {
        Object.keys(groups).map(filter => {
          obj[filter] = [ ...groups[filter] ];
        });
      });

      return data;
    },
    selectFilm_fn(val) {
      // this.showRule = {
      //   scheduleTime: "",
      //   schedule: "",
      // };
      const schedules = this.allFilmOption.find(item => item.filmId === val);
      // this.allSchedleOption = schedules ? schedules.dates : [];
      this.scheduleTimeOption = schedules ? schedules.dates : [];
      this.showRule.schedule = "";
      this.showRule.scheduleTime = "";
      this.allSchedleOption = [];
      // this.clearReportData();
      this.isShowDetail = false;
    },
    selectFilm(filmId) {
      let scheduleArr = [];

      for (let i = 0; i < this.allSchedleOption.length; i++) {
        if (this.allSchedleOption[i].filmId == filmId) {
          scheduleArr.push({ ...this.allSchedleOption[i] });
        }
      }

      this.scheduleOption = scheduleArr;
    },
    selectScheduleTime_fn(val) {
      if (val === "") {
        this.isShowDetail = false;
      }
      const schedule = this.scheduleTimeOption.find(item => item.date === val);
      this.allSchedleOption = schedule ? schedule.schedules : [];
      this.showRule.schedule = "";
    },
    clearReportData() {
      this.tableData2 = [];
      this.tableData3 = [];
      this.tableData4 = [];
      this.cinemaName = "";
      this.brandName = "";
      this.scheduleTime = "";
      this.searchTimeDetail = "";
      this.tableData1.tableData = [];
      this.searchTime = "";
      this.onSearch = {
        startDate: 0,
        endDate: 0,
      };
    },
    getDetailTable_fn(val) {
      this.clearReportData();
      this.isShowDetail = val !== "";
      // if (this.tableData4.length > 0 && this) {
      //   this.setTotalStyle();
      // }
      // getDailyScheduleRevenueReport({
      //   cinemaId: this.cinemaId,
      //   displayCouponType: "",
      //   displayNoTicketType: "",
      //   scheduleId: val,
      // }).then(res => {

      // });
    },
    selectSchedule(scheduleId) {
      if (scheduleId == "") {
        this.showRule = {
          ...this.showRule,
          movie: ""
        };
        this.tableData4 = [];
        this.isShowDetail = false;
      } else {
        let publicMsg = {};
        let dataList = [];
        let ticketTypeName_arr = [];
        let posArr = [];
        let onlineArr = [];
        let houseName = "";
        let posNum = 0;
        let posTotal = 0;
        let onlineNum = 0;
        let onlineTotal = 0;
        let tb5 = [];

        this.apiData.map(obj => {
          if (scheduleId == obj.scheduleId) {
            if (!publicMsg.filmId) {
              const {
                filmId,
                filmName,
                subtitlesVersion,
                otherVersion,
                scheduleStartTime,
                scheduleEndTime,
                ticketRuleName,
                houseName: hName,
              } = obj;

              publicMsg = {
                ...publicMsg,
                filmId,
                filmName,
                subtitlesVersion,
                otherVersion,
                scheduleStartTime,
                scheduleEndTime,
                ticketRuleName,
              };

              houseName = hName;

              // publicMsg.filmId = obj.filmId;
              // publicMsg.filmName = obj.filmName;
              // publicMsg.subtitlesVersion = obj.subtitlesVersion;
              // publicMsg.otherVersion = obj.otherVersion;
              // publicMsg.scheduleStartTime = obj.scheduleStartTime;
              // publicMsg.scheduleEndTime = obj.scheduleEndTime;
              // publicMsg.ticketRuleName = obj.ticketRuleName;

              // houseName = obj.houseName;
            }

            let ticketTypeNameIndex = ticketTypeName_arr.indexOf(obj.ticketTypeName);

            if (ticketTypeNameIndex < 0) {
              ticketTypeName_arr.push(obj.ticketTypeName);
              ticketTypeNameIndex = ticketTypeName_arr.length - 1;

              posArr[ticketTypeNameIndex] = {
                coupon: 0,
                price: obj.ticketTypePrice - obj.couponPrice,
                num: 0
              };
              onlineArr[ticketTypeNameIndex] = {
                coupon: 0,
                price: obj.ticketTypePrice - obj.couponPrice,
                num: 0
              };
            }

            if (obj.platform == "pos") {
              posArr[ticketTypeNameIndex].num = posArr[ticketTypeNameIndex].num + 1;
              posNum = posNum + 1;
              posTotal = posTotal + obj.ticketTypePrice - obj.couponPrice;
            } else {
              onlineArr[ticketTypeNameIndex].num =
                onlineArr[ticketTypeNameIndex].num + 1;
              onlineNum = onlineNum + 1;
              onlineTotal = onlineTotal + obj.ticketTypePrice - obj.couponPrice;
            }
          }
        });

        for (let i = 0; i < ticketTypeName_arr.length; i++) {
          dataList[i] = {
            ...publicMsg,
            ...posArr[i],
            lineTotal: posArr[i].num * posArr[i].price,
            ticketTypeName: ticketTypeName_arr[i],
            platform: "窓口",
          };
          // posNum = posNum + posArr[i].num;
          // posTotal = posTotal + posArr[i].price;

          dataList[ticketTypeName_arr.length + i] = {
            ...publicMsg,
            ...onlineArr[i],
            lineTotal: onlineArr[i].num * onlineArr[i].price,
            ticketTypeName: ticketTypeName_arr[i],
            platform: "ネット予約",
          };
          // onlineNum = onlineNum + onlineArr[i].num;
          // onlineTotal = onlineTotal + onlineArr[i].price;
        }

        tb5.push({
          lineTotal: posTotal,
          num: posNum,
          price: "現金·ｸﾚｼﾞｯﾄ売上合計",
          platform: "窓口",
        });
        tb5.push({
          lineTotal: 0,
          num: 0,
          price: "前売券合計",
          platform: "窓口",
        });
        tb5.push({
          lineTotal: posTotal,
          num: posNum,
          price: "窓口合計",
          platform: "窓口",
        });

        tb5.push({
          lineTotal: 0,
          num: 0,
          price: "現金·ｸﾚｼﾞｯﾄ売上合計",
          platform: "ネット予約",
        });
        tb5.push({
          lineTotal: onlineTotal,
          num: onlineNum,
          price: "前売券合計",
          platform: "ネット予約",
        });
        tb5.push({
          lineTotal: onlineTotal,
          num: onlineNum,
          price: "ネット予約合計",
          platform: "ネット予約",
        });

        tb5.push({
          lineTotal: onlineTotal + posTotal,
          num: onlineNum + posNum,
          price: "総合計",
        });

        this.showRule = {
          ...this.showRule,
          schedule: scheduleId,
          movie: publicMsg.filmId
        };
        this.houseName = houseName;
        this.scheduleTime =
          this.$moment(publicMsg.scheduleStartTime).format("YYYY-MM-DD hh:mm") +
          " ~ " +
          this.$moment(publicMsg.scheduleEndTime).format("hh:mm");
        this.tableData4 = dataList;
        this.tableData5 = tb5;
        this.isShowDetail = true;
      }
    },
    tb4_mergeSpan({ rowIndex, columnIndex }) {
      let line_num = this.tableData4.length;

      if (columnIndex < 5) {
        if (rowIndex == 0) {
          return {
            rowspan: line_num,
            colspan: 1,
          };
        }
        return {
          rowspan: 0,
          colspan: 1,
        };

      }
    },
    tb5_mergeSpan({ rowIndex, columnIndex }) {
      if (columnIndex == 0) {
        if (rowIndex == 0 || rowIndex == 3) {
          return {
            rowspan: 3,
            colspan: 1,
          };
        }
        return {
          rowspan: 0,
          colspan: 0,
        };

      }

      if (rowIndex == 6) {
        if (columnIndex == 1) {
          return {
            rowspan: 1,
            colspan: 2,
          };
        }
      }
    },
    getDetailDataArray(obj) {
      const { boxOffice, online } = obj;
      const _total = [];
      // if (boxOffice.length === 0) {
      //   _total.push({
      //     couponsName: "/",
      //     ticketName: "/",
      //     total: "/",
      //     type: "boxOffice",
      //     unitPrice: "/",
      //     uuid: "",
      //     visitor: "/",
      //   });
      // } else {
      //   boxOffice.forEach(item => {
      //     _total.push({ ...item, type: "boxOffice" });
      //   });
      // }
      if(boxOffice.length > 0 || online.length > 0) {
        if (boxOffice.length > 0) {
        boxOffice.forEach(item => {
          _total.push({ ...item, type: "boxOffice" });
        });
        } else {
          _total.push({
            couponsName: "/",
            ticketName: "/",
            total: "/",
            type: "boxOffice",
            unitPrice: "/",
            uuid: "",
            visitor: "/",
          });
        }
        if (online.length > 0) {
          online.forEach(item => {
            _total.push({ ...item, type: "online" });
          });
        } else {
          _total.push({
            couponsName: "/",
            ticketName: "/",
            total: "/",
            type: "online",
            unitPrice: "/",
            uuid: "",
            visitor: "/",
          });
        }
      }
      
      // if (online.length === 0) {
      //   _total.push({
      //     couponsName: "/",
      //     ticketName: "/",
      //     total: "/",
      //     type: "online",
      //     unitPrice: "/",
      //     uuid: "",
      //     visitor: "/",
      //   });
      // } else {
      //   online.forEach(item => {
      //     _total.push({ ...item, type: "online" });
      //   });
      // }
      return _total;
    },
    filter_fn() {
      // 如果状态为detail
      // if (this.isShowDetail) {
      //   saveFilterOptions({
      //     id: localStorage.get('loginAsAccountId') || localStorage.get('accountId'),
      //     options: {
      //       showRule: this.showRule,
      //       selectLabels: this.selectLabels,
      //     }
      //   }, 'box-office-daily')
      // } else {
      //   saveFilterOptions({
      //     id: localStorage.get('loginAsAccountId') || localStorage.get('accountId'),
      //     options: {
      //       filter: this.filter,
      //       checkboxGroup: this.checkboxGroup,
      //       mobilization: this.mobilization,
      //       showRule: this.showRule,
      //       selectLabels: this.selectLabels,
      //     }
      //   }, 'box-office-daily')
      // }
      this.getMovieList_fn();
      this.getList()
    },
    async getList() {
      if (!this.isShowDetail) {
        this.showRule.movie = "";
        this.showRule.schedule = "";
        this.showRule.scheduleTime = "";
        await getDailyMovieRevenueReportV2({
          cinemaId: this.cinemaId,
          startDate: this.$moment(this.filter.startDate).format("YYYY-MM-DD"),
          endDate: this.$moment(this.filter.endDate).format("YYYY-MM-DD"),
          version: this.checkboxGroup.indexOf("version") > -1,
          otherVersion: this.checkboxGroup.indexOf("otherVersion") > -1,
          subtitlesVersion: this.checkboxGroup.indexOf("subtitlesVersion") > -1,
          displaySamePrice: this.checkboxGroup.indexOf("displaySamePrice") > -1,
          ...this.mobilization.indexOf("freeMobilize") > -1 ? { displayAmountZero: true } : { displayAmountZero: false },
          ...this.mobilization.indexOf("adjustMobilize") > -1 ? { displayMobilize: true } : { displayMobilize: false }
        }).then(res => {
          if (res.data) {
            if (this.cinemaId != "") {
              for (let i = 0; i < this.cinemaObj.length; i++) {
                if (this.cinemaObj[i].id == this.cinemaId) {
                  this.cinemaName = this.cinemaObj[i].name;
                  break;
                }
              }
            }
            this.allFilmOption = res.data.filmSelectRecords
            this.onSearch = {
              startDate: res.data.reportOf.start,
              endDate: res.data.reportOf.end
            };
            this.searchTime = this.$moment(res.data.exportAt).format("YYYY/MM/DD HH:mm:ss");
            let formatData = [];
            let formatTicketData = [];
            let formatAccumulatedData = [];
            const { filmRecords } = res.data;
            const { boxOffice, allNight, lateShow, morningShow, special } = res.data.allTotal;

            filmRecords.forEach(record => {
              record.versionRecords.forEach(item => {
                const allNightTotal = (item.scheduleBoxOffice.allNight || {}).total || 0
                const allNightVisitor = (item.scheduleBoxOffice.allNight || {}).visitor || 0
                const boxOfficeTotal = (item.scheduleBoxOffice.boxOffice || {}).total || 0
                const boxOfficeVisitor = (item.scheduleBoxOffice.boxOffice || {}).visitor || 0
                const lateShowTotal = (item.scheduleBoxOffice.lateShow || {}).total || 0
                const lateShowVisitor = (item.scheduleBoxOffice.lateShow || {}).visitor || 0
                const morningShowTotal = (item.scheduleBoxOffice.morningShow || {}).total || 0
                const morningShowVisitor = (item.scheduleBoxOffice.morningShow || {}).visitor || 0
                const specailTotal = (item.scheduleBoxOffice.special || {}).total || 0
                const specailVisitor = (item.scheduleBoxOffice.special || {}).visitor || 0
                formatData.push({
                  filmName: record.filmName,
                  filmId: record.filmId,
                  clientName: record.clientName,
                  week: record.week,
                  version: item.version,
                  subtitlesVersion: item.subtitlesVersion,
                  otherVersion: item.otherVersion,
                  allNight: !item.scheduleBoxOffice.allNight ? { visitor: 0, total: 0 } : item.scheduleBoxOffice.allNight,
                  boxOffice: !item.scheduleBoxOffice.boxOffice ? { visitor: 0, total: 0 } : item.scheduleBoxOffice.boxOffice,
                  lateShow: !item.scheduleBoxOffice.lateShow ? { visitor: 0, total: 0 } : item.scheduleBoxOffice.lateShow,
                  morningShow: !item.scheduleBoxOffice.morningShow ? { visitor: 0, total: 0 } : item.scheduleBoxOffice.morningShow,
                  special: !item.scheduleBoxOffice.special ? { visitor: 0, total: 0 } : item.scheduleBoxOffice.special,
                  advanceTicket: {
                    visitor: item.advanceTicket.visitor,
                    total: item.advanceTicket.total
                  },
                  nationalTicket: {
                    visitor: item.nationalTicket.visitor,
                    total: item.nationalTicket.total
                  },
                  accumulated: {
                    num: item.accumulated.visitor,
                    price: item.accumulated.total
                  },
                  // total:  Object.keys(item.scheduleBoxOffice).length === 0 ? 0 :
                  //   item.scheduleBoxOffice.allNight ? item.scheduleBoxOffice.allNight.total : 0 +
                  //   item.scheduleBoxOffice.boxOffice ? item.scheduleBoxOffice.boxOffice.total : 0 +
                  //   item.scheduleBoxOffice.lateShow ? item.scheduleBoxOffice.lateShow.total : 0 +
                  //   item.scheduleBoxOffice.morningShow ? item.scheduleBoxOffice.morningShow.total : 0 +
                  //   item.scheduleBoxOffice.special ? item.scheduleBoxOffice.special.total : 0 +
                  //   item.advanceTicket ? item.advanceTicket.total : 0 +
                  //   item.nationalTicket ? item.nationalTicket.total : 0
                  total: Object.keys(item.scheduleBoxOffice).length === 0 ? { visitor: 0, total: 0} :
                  {
                    visitor: allNightVisitor + boxOfficeVisitor + lateShowVisitor + morningShowVisitor + specailVisitor,
                    total: allNightTotal + boxOfficeTotal + lateShowTotal + morningShowTotal + specailTotal
                  }
                });
                // formatTicketData.push({
                //   advanceTicket: {
                //     visitor: item.advanceTicket.visitor,
                //     total: item.advanceTicket.total
                //   },
                //   nationalTicket: {
                //     visitor: item.nationalTicket.visitor,
                //     total: item.nationalTicket.total
                //   },
                //   total: item.advanceTicket.total + item.nationalTicket.total,
                // });
                // formatAccumulatedData.push({
                //   num: item.accumulated.visitor,
                //   price: item.accumulated.total,
                // });
              });
            });
            const advanceTicket_visitorTotal = formatData.reduce((pre, cur) => {
              return pre + cur.advanceTicket.visitor;
            }, 0);
            const advanceTicket_total = formatData.reduce((pre, cur) => {
              return pre + cur.advanceTicket.total;
            }, 0);
            const nationalTicket_visitorTotal = formatData.reduce((pre, cur) => {
              return pre + cur.nationalTicket.visitor;
            }, 0);
            const nationalTicket_total = formatData.reduce((pre, cur) => {
              return pre + cur.nationalTicket.total;
            }, 0);
            const accumulated_visitorTotal = formatData.reduce((pre, cur) => {
              return pre + cur.accumulated.num;
            }, 0);
            const accumulated_total = formatData.reduce((pre, cur) => {
              return pre + cur.accumulated.price;
            }, 0);
            const allNightTotal = (allNight || {}).total || 0
            const allNightVisitor = (allNight || {}).visitor || 0
            const boxOfficeTotal = (boxOffice || {}).total || 0
            const boxOfficeVisitor = (boxOffice || {}).visitor || 0
            const lateShowTotal = (lateShow || {}).total || 0
            const lateShowVisitor = (lateShow || {}).visitor || 0
            const morningShowTotal = (morningShow || {}).total || 0
            const morningShowVisitor = (morningShow || {}).visitor || 0
            const specailTotal = (special || {}).total || 0
            const specailVisitor = (special || {}).visitor || 0
            formatData.push({
              filmId: "",
              filmName: "合計",
              version: "",
              subtitlesVersion: "",
              otherVersion: "",
              week: "",
              clientName: "",
              boxOffice: {
                visitor: !boxOffice ? 0 : boxOffice.visitor,
                total: !boxOffice ? 0 : boxOffice.total,
              },
              allNight: {
                visitor: !allNight ? 0 : allNight.visitor,
                total: !allNight ? 0 : allNight.total,
              },
              lateShow: {
                visitor: !lateShow ? 0 : lateShow.visitor,
                total: !lateShow ? 0 : lateShow.total,
              },
              morningShow: {
                visitor: !morningShow ? 0 : morningShow.visitor,
                total: !morningShow ? 0 : morningShow.total,
              },
              special: {
                visitor: !special ? 0 : special.visitor,
                total: !special ? 0 : special.total,
              },
              advanceTicket: {
                visitor: advanceTicket_visitorTotal,
                total: advanceTicket_total
              },
              nationalTicket: {
                visitor: nationalTicket_visitorTotal,
                total: nationalTicket_total
              },
              accumulated: {
                num: accumulated_visitorTotal,
                price: accumulated_total
              },
              total: !boxOffice && !allNight && !lateShow && !morningShow && !special ? {
                visitor: 0,
                total: 0
              } : 
              {
                visitor: allNightVisitor + boxOfficeVisitor + lateShowVisitor + morningShowVisitor + specailVisitor,
                total: allNightTotal + boxOfficeTotal + lateShowTotal + morningShowTotal + specailTotal
              }
            });

            this.tableData1.tableData = formatData;
            this.tableData1_original = formatData;
            this.tableData2 = formatTicketData;
            this.tableData3 = formatAccumulatedData;
            this.allFilmOption = res.data.filmSelectRecords;
          } else {
            this.searchTime = "";
            this.onSearch = {
              startDate: 0,
              endDate: 0,
            };
            this.tableData1.tableData = [];
            this.tableData1_original = [];
            this.tableData2 = [];
            this.tableData3 = [];
          }
        });
      } else {
        this.tableData4 = [];
        getDailyScheduleRevenueReport({
          cinemaId: this.cinemaId,
          displayCouponType: this.showRule.coupon.indexOf("notUseCoupon") > -1,
          displayNoTicketType: this.showRule.coupon.indexOf("showDetail") > -1,
          displayAmountZero: this.showRule.mobilization.indexOf("freeMobilize") > -1,
          displayMobilize: this.showRule.mobilization.indexOf("adjustMobilize") > -1,
          displaySamePrice: this.showRule.coupon.indexOf("displaySamePrice") > -1,
          displayUnitPriceZero: this.showRule.coupon.indexOf("displayUnitPriceZero") > -1,
          scheduleId: this.showRule.schedule,
        }).then(res => {
          if (res.success && res.data) {
            this.scheduleTime = this.$moment(res.data.scheduleTime.start).format("YYYY-MM-DD") + " " +
            this.$moment(res.data.scheduleTime.start).format("HH:mm") + " ~ " + this.$moment(res.data.scheduleTime.end).format("HH:mm");
            this.cinemaName = res.data.cinemaName;
            this.brandName = res.data.brandName;
            this.houseName = res.data.filmRecords[0].houseName;
            this.searchTimeDetail = this.$moment(res.data.exportAt).format("YYYY/MM/DD HH:mm:ss");
            let formatData = [];
            const { filmRecords }  = res.data;
            const salesType = {
              boxOffice: this.$locale("global.window"),
              online: this.$locale("trans.box.online")
            };
            // const ticketRules = [
            //   this.$locale("movie.mainBusiness"),
            //   this.$locale("movie.morningShow"),
            //   this.$locale("movie.lateShow"),
            //   this.$locale("movie.allNight"),
            //   this.$locale("movie.specialBusiness"),
            // ];
            filmRecords.forEach(film => {
              this.getDetailDataArray(film.scheduleBoxOffice.boxOffice).forEach(data => {
                formatData.push({
                  filmName: film.filmName,
                  version: film.version,
                  subtitlesVersion: film.subtitlesVersion,
                  otherVersion: film.otherVersion,
                  ticketRuleName: this.$locale("movie.mainBusiness"),
                  platform: salesType[data.type],
                  ticketTypeName: data.ticketName,
                  coupon: data.couponsName,
                  price: data.unitPrice,
                  num: data.visitor,
                  lineTotal: data.total,
                  isTotal: -1,
                });
              });
              this.getDetailDataArray(film.scheduleBoxOffice.morningShow).forEach(data => {
                formatData.push({
                  filmName: film.filmName,
                  version: film.version,
                  subtitlesVersion: film.subtitlesVersion,
                  otherVersion: film.otherVersion,
                  ticketRuleName: this.$locale("movie.morningShow"),
                  platform: salesType[data.type],
                  ticketTypeName: data.ticketName,
                  coupon: data.couponsName,
                  price: data.unitPrice,
                  num: data.visitor,
                  lineTotal: data.total,
                  isTotal: -1,
                });
              });
              this.getDetailDataArray(film.scheduleBoxOffice.lateShow).forEach(data => {
                formatData.push({
                  filmName: film.filmName,
                  version: film.version,
                  subtitlesVersion: film.subtitlesVersion,
                  otherVersion: film.otherVersion,
                  ticketRuleName: this.$locale("movie.lateShow"),
                  platform: salesType[data.type],
                  ticketTypeName: data.ticketName,
                  coupon: data.couponsName,
                  price: data.unitPrice,
                  num: data.visitor,
                  lineTotal: data.total,
                  isTotal: -1,
                });
              });
              this.getDetailDataArray(film.scheduleBoxOffice.allNight).forEach(data => {
                formatData.push({
                  filmName: film.filmName,
                  version: film.version,
                  subtitlesVersion: film.subtitlesVersion,
                  otherVersion: film.otherVersion,
                  ticketRuleName: this.$locale("movie.allNight"),
                  platform: salesType[data.type],
                  ticketTypeName: data.ticketName,
                  coupon: data.couponsName,
                  price: data.unitPrice,
                  num: data.visitor,
                  lineTotal: data.total,
                  isTotal: -1,
                });
              });
              this.getDetailDataArray(film.scheduleBoxOffice.special).forEach(data => {
                formatData.push({
                  filmName: film.filmName,
                  version: film.version,
                  subtitlesVersion: film.subtitlesVersion,
                  otherVersion: film.otherVersion,
                  ticketRuleName: this.$locale("movie.specialBusiness"),
                  platform: salesType[data.type],
                  ticketTypeName: data.ticketName,
                  coupon: data.couponsName,
                  price: data.unitPrice,
                  num: data.visitor,
                  lineTotal: data.total,
                  isTotal: -1,
                });
              });
              const totals_window = [
                {
                  name: this.$locale("trans.box.cashTotal"),
                  key: "cash"
                },
                {
                  name: this.$locale("trans.box.mvtk"),
                  key: "national"
                },
                {
                  name: this.$locale("trans.box.advanceTotal"),
                  key: "advanceSales"
                },
                {
                  name: this.$locale("trans.box.invitation"),
                  key: "invitation"
                },
                {
                  name: this.$locale("tran.box.windowTotal"),
                  key: "total"
                }
              ];
              const totals_online = [
                {
                  name: this.$locale("trans.box.cashTotal"),
                  key: "creditCard"
                },
                {
                  name: this.$locale("trans.box.mvtk"),
                  key: "national"
                },
                {
                  name: this.$locale("trans.box.advanceTotal"),
                  key: "advanceSales"
                },
                {
                  name: this.$locale("trans.box.invitation"),
                  key: "invitation"
                },
                {
                  name: this.$locale("tran.box.onlineTotal"),
                  key: "total"
                }
              ];
              for(let i = 0; i < 5; i++) {
                formatData.push({
                  filmName: "",
                  version: "",
                  subtitlesVersion: "",
                  otherVersion: "",
                  ticketRuleName: "",
                  platform: this.$locale("global.window"),
                  ticketTypeName: totals_window[i].name,
                  coupon: "",
                  price: "",
                  isTotal: 0,
                  num: film.boxOfficeSummaries[0].cash ? film.boxOfficeSummaries[0][totals_window[i].key].visitor : "/",
                  lineTotal: film.boxOfficeSummaries[0].cash ? film.boxOfficeSummaries[0][totals_window[i].key].total : "/",
                });
              }
              for(let i = 0; i < 5; i++) {
                formatData.push({
                  filmName: "",
                  version: "",
                  subtitlesVersion: "",
                  otherVersion: "",
                  ticketRuleName: "",
                  platform: this.$locale("trans.box.online"),
                  ticketTypeName: totals_online[i].name,
                  coupon: "",
                  price: "",
                  isTotal: 0,
                  num: film.onlineSummaries[0].creditCard ? film.onlineSummaries[0][totals_online[i].key].visitor : "/",
                  lineTotal: film.onlineSummaries[0].creditCard ? film.onlineSummaries[0][totals_online[i].key].total : "/",
                });
              }
              formatData.push({
                filmName: "",
                version: "",
                subtitlesVersion: "",
                otherVersion: "",
                ticketRuleName: "",
                platform: "",
                ticketTypeName: this.$locale("trans.box.allTotal"),
                coupon: "",
                price: "",
                isTotal: 0,
                num: film.allTotal.visitor,
                lineTotal: film.allTotal.total
              });
            });

            this.tableData4 = sortBy(formatData, ["isTotal", "filmName", "version", "subtitlesVersion", "otherVersion"]);
            // this.tableData4 = formatData;
            this.$nextTick(() => {
              this.setTotalStyle();
            });
          }
        });
      }
    },
    setTotalStyle() {
      document.querySelectorAll(".boxDetail tbody .el-table__row")[this.tableData4.length - 7].className = "bg el-table__row";
      document.querySelectorAll(".boxDetail tbody .el-table__row")[this.tableData4.length - 2].className = "bg el-table__row";
      document.querySelectorAll(".boxDetail tbody .el-table__row")[this.tableData4.length - 1].className = "bg el-table__row";
    },
    getVersionText_fn(row, type) {
      let arr = [];
      row.versionRecords.forEach(item => {
        arr.push(item[type]);
      });
      return [ ...new Set(arr) ].join(",");
    },
    objectSpanMethod({ row, columnIndex }) {
      if (row.filmName === "合計") {
        // const num = this.tableData1.tableData.every(item => !item.otherVersion) ? 5 : 6
        let num
        if (this.selectLabels.length === 6) {
          num = 6
        } else if (this.selectLabels.includes('cumulativeDevelopment')) {
          num = this.selectLabels.length
        } else {
          num = this.selectLabels.length + 1
        }
        if (columnIndex === 0) {
          return [1,num];
        } else if (columnIndex > 0 && columnIndex < num) {
          return [0,0];
        }
      }
    },
    priceFormatter_fn(row, column, cellValue) {
      switch(column.property) {
      case "lateShow.total":
        return cellValue === "/" ? cellValue : toThousands(cellValue) + this.$locale("global.circle");
      case "morningShow.total":
        return cellValue === "/" ? cellValue : toThousands(cellValue) + this.$locale("global.circle");
      case "allNight.total":
        return cellValue === "/" ? cellValue : toThousands(cellValue) + this.$locale("global.circle");
      case "special.total":
        return cellValue === "/" ? cellValue : toThousands(cellValue) + this.$locale("global.circle");
      case "boxOffice.total":
        return cellValue === "/" ? cellValue : toThousands(cellValue) + this.$locale("global.circle");
      case "total.total":
      return cellValue === "/" ? cellValue : toThousands(cellValue) + this.$locale("global.circle");
      case "advanceTicket.total":
        return toThousands(cellValue) + this.$locale("global.circle");
      case "nationalTicket.total":
        return toThousands(cellValue) + this.$locale("global.circle");
      case "accumulated.price":
        return toThousands(cellValue) + this.$locale("global.circle");
      case "total":
        return cellValue === "/" ? cellValue : toThousands(cellValue) + this.$locale("global.circle");
      case "price":
        return toThousands(cellValue) + this.$locale("global.circle");
      default:
        break;
      }
    },
    getScheduleFormatTime(timestamp) {
      return this.$moment(timestamp).format("HH:mm");
    },
    sort_pro(data, keys = []) {
      let c = [];
      let d = [];
      for (let  element of data) {
        let element_keyStr = "";
        let element_key = [];
        let element_keyObj = {};
        for (let key of keys) {
          element_key.push(element[key]);
          element_keyObj[key] = element[key];
        }
        element_keyStr = element_key.join("_");
        if (!d[element_keyStr]) {
          c.push({
            ...element_keyObj,
            children: [ element ]
          });
          d[element_keyStr] = element;
        } else {
          for (let  ele of c) {
            let isTrue = keys.some(key => {
              return ele[key] != element[key];
            });
            if (!isTrue) {
              ele.children.push(element);
            }
          }
        }
      }
      return c;
    },
    getCount(model, key) {
      let spanArr = [];
      let pos = 0;
      for (let i = 0; i < model.length; i++) {
        if (i === 0) {
          spanArr.push(1);
          pos = 0;
        } else if (model[i][key] === model[i - 1][key] && model[i].filmName === model[i - 1].filmName) {
          spanArr[pos] += 1;
          spanArr.push(0);
        } else {
          spanArr.push(1);
          pos = i;
        }
      }
      return spanArr;
    },
    mergeComon(key, rowIndex, columnIndex) {
      if(key === 'ticketRuleName') {
        console.log(rowIndex)
      }
      const _row = this.getCount(this.tableData4, key)[rowIndex];
      const _col = _row > 0 ? 1 : 0;
      // if (rowIndex === this.tableData4.length - 6) {
      //   if (columnIndex === 0) {
      //     return {
      //       rowspan: _row,
      //       colspan: 5
      //     };
      //   } else if (columnIndex < 5) {
      //     return  {
      //       rowspan: _row,
      //       colspan: 0
      //     };
      //   }
      // }
      return {
        rowspan: _row,
        colspan: _col
      };
    },
    merge4arrayMethod({ row, rowIndex, columnIndex }) {
      const offset = this.tableData4.some(item => item.otherVersion) ? 0 : 1
      console.log(offset)
      switch(columnIndex) {
      case 0:
        return this.mergeComon("filmName", rowIndex);
      case 1:
        return this.mergeComon("version", rowIndex);
      case 2:
        return this.mergeComon("subtitlesVersion", rowIndex);
      case 3:
        return offset === 0 ? this.mergeComon("otherVersion", rowIndex, columnIndex) : this.mergeComon("ticketRuleName", rowIndex, columnIndex);
      case 4 - offset:
        return this.mergeComon("ticketRuleName", rowIndex, columnIndex);
      case 5 - offset:
        return this.mergeComon("platform", rowIndex, columnIndex);
      default:
        break;
      }
    
      if (columnIndex === 6 - offset) {
        if (row.isTotal === 0) {
          return {
            rowspan: 1,
            colspan: 3
          };
        }
      } else if (rowIndex > this.tableData4.length - 12 && columnIndex > 6 - offset && columnIndex < 9 - offset) {
        return {
          rowspan: 1,
          colspan: 0,
        };
      }
    },
    boxDetailFormatter(row, column, cellValue) {
      switch(column.property) {
      case "price":
        return cellValue !== "/" ? toThousands(cellValue) + this.$locale("global.circle") : cellValue;
      case "num":
        return cellValue !== "/" ? toThousands(cellValue) : cellValue;
      case "lineTotal":
        return cellValue !== "/" ? toThousands(cellValue) + this.$locale("global.circle") : cellValue;
      default:
        break;
      }
    },
    filterDataGroup_fn(item, filters, type, arr) {
      if (filters[type]) {
        if(item[type].indexOf("、") > -1) {
          let splitArr = item[type].split("、");
          if (intersection(filters[type], splitArr).length > 0) {
            arr.push(item);
          }
        } else if (filters[type].indexOf(item[type]) > -1) {
          arr.push(item);
        }
      }
    },
    filterChange_fn(filters) {
      let _arr = [];
      this.tableData1_original.forEach(item => {
        this.filterDataGroup_fn(item, filters, keys(filters)[0], _arr);
      });
      this.tableData1.tableData = _arr;
    },
    async getMovieList_fn() {
      try {
        const res = await getFilmList({
          cinemaId: this.cinemaId,
          startDate: this.$moment(this.filter.startDate).format("YYYY-MM-DD"),
          endDate: this.$moment(this.filter.endDate).format("YYYY-MM-DD"),
        });

        if (res.success && res.data) {
          res.data.forEach(item => {
            this.filterTypes.films.push({
              text: item.name,
              value: item.id
            });
            this.filterValues.films.push(item.id);
          });
        }
      } catch (error) {
        console.error("Error fetching film list:", error);
      }
      // await getFilmList({
      //   cinemaId: this.cinemaId,
      //   startDate: this.$moment(this.filter.startDate).format("YYYY-MM-DD"),
      //   endDate: this.$moment(this.filter.endDate).format("YYYY-MM-DD"),
      // }).then(res => {
      //   if (res.success && res.data) {
      //     res.data.forEach(item => {
      //       this.filterTypes.films.push({
      //         text: item.name,
      //         value: item.id
      //       });
      //       this.filterValues.films.push(item.id);
      //     });
      //   }
      // });
    },
    async loadOptionsAndProcess(val) {
      const { checkboxGroup, mobilization, filter } = val.options
      this.filter = filter;
      this.checkboxGroup = checkboxGroup;
      this.mobilization = mobilization;

      await this.getMovieList_fn();
      await this.getList();


      if (val.options.showRule) {
        const { coupon, mobilization, movie, scheduleTime, schedule, selectLabels } = val.options.showRule;
        this.showRule.coupon = coupon;
        this.showRule.mobilization = mobilization;
        this.selectLabels = val.options.selectLabels;

        
        // mapping movieId是否存在于list 存在才赋值
        if (this.allFilmOption.findIndex(item => item.filmId === movie) > -1) {
          this.showRule.movie = movie
          // 根据movieId获取schedule和schedule时间
          this.selectFilm_fn(movie);
          this.showRule.scheduleTime = scheduleTime;
          this.selectScheduleTime_fn(scheduleTime);
          this.showRule.schedule = schedule;
          this.getDetailTable_fn(schedule);
        }
      }
    },
    getTotalPrice(data, type) {
      function formatPrice(data) {
        return isNaN(data) ? 0 : data;
      }
      let {
        boxOffice: { total: boxOfficeTotal },
        allNight: { total: allNightTotal },
        lateShow: { total: lateShowTotal },
        morningShow: { total: morningShowTotal },
        special: { total: specialTotal },
        nationalTicket: { total: nationalTicketTotal },
        advanceTicket: { total: advanceTicketTotal }
      } = data;
      return type === "boxOffice" ?
        toThousands(formatPrice(boxOfficeTotal) + formatPrice(allNightTotal) + formatPrice(lateShowTotal) +
      formatPrice(morningShowTotal) + formatPrice(specialTotal)) + "円" :
        toThousands(nationalTicketTotal + advanceTicketTotal) + "円";
    },
    getIsExistBoxOffice(key) {
      if (!this.showRule.coupon.includes("withoutTransactions") && this.tableData1.tableData.length > 0) {
        // console.log(!this.tableData1.tableData.every(item => isNaN(item[key].visitor) && isNaN(item[key].total)))
        // return !this.tableData1.tableData.every(item => isNaN(item[key].visitor) && isNaN(item[key].total));
        if (key === 'otherVersion' && this.tableData1.tableData.every(item => !item.otherVersion)) {
          return false
        }
        else if(this.tableData1.tableData.every(item => item[key].visitor === 0)) {
          return false
        }
      }
      return true;
    },
    getIsNeedTotal() {
      if (!this.showRule.coupon.includes("withoutTransactions") && this.tableData1.tableData.length > 0) {
        return this.getIsExistBoxOffice("boxOffice") && this.getIsExistBoxOffice("allNight") && this.getIsExistBoxOffice("lateShow")
      && this.getIsExistBoxOffice("morningShow") && this.getIsExistBoxOffice("special");
      }
      return true;
    },
    selectLabel_fn(val) {
      setStorageModule_fn('boxOfficeDaily', val)
    }
  },
  created() {
    getVersion({
      cinemaId: this.cinemaId,
      page: 0,
      pageSize: 9999
    }).then(res => {
      res.data.data.forEach(item => {
        this.filterTypes.versions.push({
          text: item.name,
          value: item.name
        });
        this.filterValues.versions.push(item.name);
      });
    });
    getOtherVersion({
      cinemaId: this.cinemaId,
      page: 0,
      pageSize: 9999,
    }).then(res => {
      res.data.data.forEach(item => {
        this.filterTypes.otherVersions.push({
          text: item.name,
          value: item.name
        });
        this.filterValues.otherVersions.push(item.name);
      });
    });
    const today = this.$moment().valueOf();
    this.filter = {
      startDate: today,
      endDate: today
    };
    this.onSearch = {
      startDate: today,
      endDate: today
    };
  },
  mounted() {
    // await this.loadOptions('box-office-daily', async (val) => {
    //   await this.loadOptionsAndProcess(val);
    // })
    this.getList();
  },
  components: {
    DatePickerGroup,
  },
  watch: {
    "filter.startDate"(newVal, oldVal) {
      if (newVal != oldVal && oldVal != 0) {
        this.showRule.movie = "";
        // this.getMovieList_fn();
      }
    },
    "filter.endDate"(newVal, oldVal) {
      if (newVal != oldVal && oldVal != 0) {
        this.showRule.movie = "";
        // this.getMovieList_fn();
      }
    },
  },
  computed: {
    ...mapState("app", {
      cinemaId: state => state.cinemaId,
      cinemaObj: state => state.cinemaObj,
    }),
  }
};
</script>

<style lang="less" scoped>
  .boxPeriod tbody td[colspan="6"], .boxDetail tbody .bg td[colspan="3"] {
    background-color: #F6E8A4;
    text-align: right;
  }
  #print {
    display: inline-block;
  }
  .boxOffice {
    ::v-deep th, ::v-deep td {
      padding: 0;
    }
    ::v-deep td div {
      padding: 0 3px;
    }
  }
</style>
